import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"position":"relative","width":"98%","height":"100%"} }
const _hoisted_2 = {
  key: 0,
  class: "pdf-pop-link"
}
const _hoisted_3 = ["href", "download"]
const _hoisted_4 = { style: {"width":"100%","height":"100%"} }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([_ctx.$props.isImg ? 'background: black' : '', {"width":"100%"}]),
    class: _normalizeClass(_ctx.show ? 'error-msg-wrap' : 'hide')
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.downloadString)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", {
              href: _ctx.pdfURL,
              target: "_blank",
              download: _ctx.downloadString
            }, "Open in new tab", 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close())),
        class: "remove-filter",
        style: {"background":"black","border-radius":"50%","width":"auto","fill":"white","top":"-5px","right":"-5px","height":"32px"},
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.094l-4.157-4.104 4.1-4.141-1.849-1.849-4.105 4.159-4.156-4.102-1.833 1.834 4.161 4.12-4.104 4.157 1.834 1.832 4.118-4.159 4.143 4.102 1.848-1.849z" }, null, -1)
      ]))])),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("iframe", {
          style: {"width":"100%","height":"100%"},
          src: _ctx.pdfURL
        }, null, 8, _hoisted_5)
      ])
    ])
  ], 6))
}